const PROFILE_IMAGE_SIZE = 200;
const MAX_IMAGE_SIZE = 6 * 1024 * 1024;

function capturePhotoFromVideo(video, fileName = 'profile-photo.jpg') {
	return new Promise((resolve, reject) => {
		if (!video || !video.videoWidth) {
			reject(new Error('Camera is not ready'));
			return;
		}

		const canvas = document.createElement('canvas');
		canvas.width = video.videoWidth;
		canvas.height = video.videoHeight;

		const ctx = canvas.getContext('2d');
		ctx.drawImage(video, 0, 0);

		canvas.toBlob((blob) => {
			if (!blob) {
				reject(new Error('Could not capture photo'));
				return;
			}

			resolve(new File([blob], fileName, {
				type: 'image/jpeg',
				lastModified: Date.now()
			}));
		}, 'image/jpeg', 0.9);
	});
}

function resizeImage(file, size = PROFILE_IMAGE_SIZE) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = (e) => {
			const img = new Image();

			img.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = size;
				canvas.height = size;

				const ctx = canvas.getContext('2d');
				const cropSize = Math.min(img.width, img.height);
				const sx = (img.width - cropSize) / 2;
				const sy = (img.height - cropSize) / 2;

				ctx.drawImage(img, sx, sy, cropSize, cropSize, 0, 0, size, size);

				canvas.toBlob((blob) => {
					if (!blob) {
						reject(new Error('Could not resize image'));
						return;
					}

					const resizedFile = new File([blob], file.name, {
						type: 'image/jpeg',
						lastModified: Date.now()
					});
					resolve(resizedFile);
				}, 'image/jpeg', 0.9);
			};

			img.onerror = () => reject(new Error('Could not load image'));
			img.src = e.target.result;
		};

		reader.onerror = () => reject(new Error('Could not read image'));
		reader.readAsDataURL(file);
	});
}

export default {
	PROFILE_IMAGE_SIZE,
	MAX_IMAGE_SIZE,
	capturePhotoFromVideo,
	resizeImage
};
